import React, { useState, useEffect } from 'react'
import { SketchPicker } from 'react-color'
import { PRESET_COLORS } from '../action/Config'

const ColorPicker = ({
  updateColor,
  color,
  title = '',
  isReturnColor = false,
  className = '',
  pickerWidth = '300px',
  popoverStyle = {},
  swatchClassName = '',
}) => {
  const [displayPicker, setDisplayPicker] = useState(false)
  const [render, setRender] = useState(false)
  const [colorDisplay, setColorDisplay] = useState(color)

  const handleChange = (color) => {
    updateColor(isReturnColor ? color : color.hex)
    setRender(true)
    setColorDisplay(color.hex)
  }

  const handleClick = () => {
    setDisplayPicker(!displayPicker)
  }

  const handleClose = () => {
    setDisplayPicker(false)
  }

  const styles = {
    color: {
      backgroundColor: colorDisplay || '#000000',
      width: '25px',
      height: '25px',
      borderRadius: '2px',
    },
    swatch: {
      padding: '2px',
      background: '#fff',
      borderRadius: '1px',
      boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
      display: 'inline-block',
      cursor: 'pointer',
    },
    popover: {
      position: 'absolute',
      zIndex: '100',
      ...popoverStyle,
    },
    cover: {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    },
  }

  useEffect(() => {
    if (color) {
      setColorDisplay(color)
    }
  }, [color])

  useEffect(() => {
    if (render) {
      setRender(false)
    }
  }, [render])

  return (
    <>
      <div className={`d-flex align-items-center ${className}`}>
        {title && <label className="w-auto m-0">{title}</label>}
        <div
          className={swatchClassName}
          style={styles.swatch}
          onClick={handleClick}
        >
          <div style={styles.color} />
        </div>
      </div>
      {displayPicker ? (
        <div className="mt-2" style={styles.popover}>
          <div style={styles.cover} onClick={handleClose} />
          <SketchPicker
            width={pickerWidth}
            color={colorDisplay || color}
            onChange={handleChange}
            presetColors={PRESET_COLORS}
          />
        </div>
      ) : null}
    </>
  )
}

export default ColorPicker
